import { Spin } from 'antd';
import { observer } from 'mobx-react-lite';
import { useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { GdList, ItemMode } from '../../../components/GdList';
import { GdLoadingIndicator } from '../../../components/GdLoadingIndicator';
import { useRootStore } from '../../../context/storeContext';
import { ListContainer } from '../../Common/styles';
import { useOrganizationQuery } from '../hooks/useOrganizationQuery';
import { useOrganizationsMeta } from '../hooks/useOrganizationsMeta';
import { OrgDeleteModal } from './OrgDeleteModal';

type DeleteTarget = { id: string; name: string };

export const OrganizationsList = observer(() => {
  const history = useHistory();

  const { orgListStore, authStore } = useRootStore();
  const { loading, loadMoreOrgs } = useOrganizationQuery();
  const [deleteTarget, setDeleteTarget] = useState<DeleteTarget | null>(null);

  const onSelectOrg = useCallback(
    (org: any) => {
      history.push(`/admin/organizations/${org.id}`);
    },
    [history]
  );

  const currentTenantId = authStore.signedInUser.companyId;

  const onDeleteOrg = useCallback(
    (org: any) => {
      if (org.id === currentTenantId) {
        return;
      }
      setDeleteTarget({ id: org.id as string, name: org.name as string });
    },
    [currentTenantId]
  );

  const listMeta = useOrganizationsMeta({
    onOrgSelected: onSelectOrg,
    onOrgDelete: onDeleteOrg,
    currentTenantId,
  });

  const { orgs, amountInfo } = orgListStore;

  return (
    <ListContainer>
      <GdList
        split={false}
        heightDelta={415}
        itemMode={ItemMode.Card}
        data={orgs}
        columnMeta={listMeta}
        loadMore={loadMoreOrgs as any}
        totalCount={amountInfo.amountLeft}
        onItemClick={onSelectOrg}
        loading={{
          spinning: loading,
          size: 'large',
          indicator: <Spin indicator={<GdLoadingIndicator />} />,
        }}
      />
      {deleteTarget && (
        <OrgDeleteModal
          orgId={deleteTarget.id}
          orgName={deleteTarget.name}
          onClose={() => setDeleteTarget(null)}
          onDeleted={() => {
            setDeleteTarget(null);
            orgListStore.clear();
            loadMoreOrgs();
          }}
        />
      )}
    </ListContainer>
  );
});
